import React from 'react'
import styles from './FormField.module.css'
import { FormFieldProps } from './types'

export const FormField = ({
    label,
    placeholder,
    value,
    onChange,
    onBlur,
    isInputType,
    inputMode,
    autoComplete,
    disabled,
    maxLength,
    onKeyDown,
    onCompositionStart,
    onCompositionUpdate,
    onCompositionEnd,
    id,
    name,
}: FormFieldProps) => {
    return (
        <div>
            <p className={styles.description}>{label}</p>
            <div className={styles.textinput}>
                <input
                    id={id}
                    name={name}
                    placeholder={placeholder}
                    type={isInputType ? isInputType : 'text'}
                    inputMode={inputMode}
                    autoComplete={autoComplete}
                    className={`${styles.input} ${disabled ? styles.disabled : ''}`}
                    value={value}
                    onChange={e => onChange(e.target.value)}
                    onBlur={onBlur}
                    disabled={disabled}
                    maxLength={maxLength}
                    onKeyDown={onKeyDown}
                    onCompositionStart={onCompositionStart}
                    onCompositionUpdate={onCompositionUpdate}
                    onCompositionEnd={onCompositionEnd}
                />
            </div>
        </div>
    )
}
